// Single-value meta tags (can only appear once)
export const micrositeSingleValueMetaTags = [
  'title',
  'description',
  'author',
  'viewport',
  'robots',
  'googlebot',
  'charset',
  'generator',
  'application-name',
  'theme-color',
] as const
